module.exports = __webpack_public_path__ + "images/emoji/city_sunset.cb6168bb683b950ed053.png";